// Dates typed into a browser date box (<input type="date">). Chrome takes a typed 2-digit year
// literally, so "28/09/26" becomes 0026-09-28. SAP keeps that on a Purchase Request line but
// cannot make a PO from it (KSA, Oct 2026), and the backend refuses years outside 2000-2099.

/** 0026-09-28 → 2026-09-28; any other value is returned unchanged (trimmed). */
export function fixTwoDigitYear(value: unknown): string {
  const s = String(value ?? '').trim()
  const m = /^00(\d{2})(-\d{2}-\d{2})$/.exec(s)
  return m ? `20${m[1]}${m[2]}` : s
}

/** A YYYY-MM-DD date with a year from 2000 to 2099. */
export function isDocumentDate(value: unknown): boolean {
  const m = /^(\d{4})-\d{2}-\d{2}$/.exec(String(value ?? '').trim())
  return !!m && Number(m[1]) >= 2000 && Number(m[1]) <= 2099
}
